import React, { Component } from 'react';
import { Field } from 'redux-form';
import { BooleanInput } from 'react-admin';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import classnames from 'classnames';
import Collapse from '@material-ui/core/Collapse';
import { createStyles, withStyles } from '@material-ui/core/styles';

import FilterCardTitle from './FilterCardTitle';
import isPresent from '../Utils/Present';

const styles = createStyles({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto'
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  header: {
    fontSize: '1.15em'
  }
});

type Props = {
  classes: any,
  rootName: string,
  title: string,
  values: boolean
};

type StateProps = {
  expanded: boolean
};

class FilterCardBoolean extends Component<Props, StateProps> {
  state = {
    expanded: false
  };

  componentDidMount() {
    this.setState({ expanded: isPresent(this.props.values) });
  }

  handleExpandClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    return (
      <Card>
        <CardHeader title={<FilterCardTitle title={this.props.title} values={this.props.values} />} classes={{ title: this.props.classes.header }} action={
          <IconButton className={
            classnames(this.props.classes.expand, { [this.props.classes.expandOpen]: this.state.expanded })
          } onClick={this.handleExpandClick} aria-expanded={this.state.expanded}>
            <ExpandMoreIcon />
          </IconButton>
        } />
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography component="div">
              <Field name={`${this.props.rootName}.values`} source={`${this.props.rootName}.values`} component={BooleanInput} label={this.props.title} style={{ width: '140px' }} />
            </Typography>
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

export default withStyles(styles)(FilterCardBoolean);



// WEBPACK FOOTER //
// ./src/views/Common/FilterComponents/FilterCardBoolean.tsx